import { useEffect, useRef } from 'react';
import { useAppStore } from '@/state/appStore';

export const useTweakPane = () => {
  const isInitialized = useRef<boolean>(false);
  const { pane, initPane, togglePaneVisibility } = useAppStore((state) => ({
    initPane: state.initPane,
    togglePaneVisibility: state.togglePaneVisibility,
    pane: state.pane,
  }));

  useEffect(() => {
    if (!isInitialized.current) {
      initPane();
      isInitialized.current = true;
    }

    const handleKeyPress = (event: KeyboardEvent) => {
      if ((event.metaKey || event.ctrlKey) && (event.key === 'b' || event.key === 'B')) {
        togglePaneVisibility();
      }
    };
    window.addEventListener('keydown', handleKeyPress);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [initPane, togglePaneVisibility]);

  return { pane };
};
